import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Check, ArrowForward } from "@material-ui/icons";

const LocationSelectButton = ({ location, selectedLocation, handleClick }) => {
  const { t } = useTranslation();
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(parseInt(location.id) === parseInt(selectedLocation.id));
  }, [selectedLocation, location]);

  return (
    <Button
      data-cy={
        isSelected ? "button-location-selected" : "button-location-select"
      }
      onClick={() => handleClick(location)}
      startIcon={isSelected ? <Check /> : null}
      endIcon={!isSelected ? <ArrowForward /> : null}
      color={isSelected ? "primary" : "default"}
      disabled={!location.slots_available || location.slots_available < 0}
    >
      {isSelected
        ? t("components.location_card.button.selected")
        : t("components.location_card.button.unselected")}
    </Button>
  );
};

export { LocationSelectButton };
